import { makeStyles } from '@material-ui/core/styles';
export var useStyles2 = makeStyles(function (theme) { return ({
    form: {
        padding: theme.spacing(2),
    },
}); });
